import { RiskKeys } from '@/config';
import { ComplianceAlertsData } from '@/redux/models';

export const alertsDemoData: ComplianceAlertsData = {
  entries: [
    {
      key: '1',
      id: '1',
      user: 'John Doe',
      address: '0x1234567890abcdef',
      direction: 'income',
      risk: 'low',
      riskyFunds: 100,
      entityCategory: RiskKeys.EXCHANGE,
      state: 'new',
      date: '2021-09-01',
      customer: [
        {
          id: '1',
          name: 'John Doe',
          identifier: 'John Doe',
          level: 'medium',
        },
      ],
    },
    {
      key: '2',
      id: '2',
      user: 'Jane Doe',
      address: '0xabcdef1234567890',
      direction: 'outcome',
      risk: 'medium',
      riskyFunds: 200,
      entityCategory: RiskKeys.TRUSTED_EXCHANGE,
      state: 'pending',
      date: '2021-09-02',
      customer: [
        {
          id: '1',
          name: 'John Doe',
          identifier: 'John Doe',
          level: 'medium',
        },
      ],
    },
    {
      key: '3',
      id: '3',
      user: 'Alice Doe',
      address: '0x1234567890abcdef',
      direction: 'income',
      risk: 'high',
      riskyFunds: 300,
      entityCategory: RiskKeys.WALLET,
      state: 'confirmed',
      date: '2021-09-03',
      customer: [
        {
          id: '1',
          name: 'John Doe',
          identifier: 'John Doe',
          level: 'medium',
        },
      ],
    },
  ],
  total: 3,
};
